import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { EventCountdownGrabber } from './components/EventCountdownGrabber';
import { EVENT_COUNTDOWN_SCHEMA_URL, EVENT_COUNTDOWN_COMPONENT_TYPE } from './EventCountdown.constants';

const EventCountdownAdd = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorEventCountdownAdd" */ './components/EventCountdownAdd'),
  'EventCountdownAdd',
);

const EventCountdownEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorEventCountdownEdit" */ './components/EventCountdownEdit'),
  'EventCountdownEdit',
);

export const EventCountdownConfig: AdminJsonComponentConfig = {
  schemaUrl: EVENT_COUNTDOWN_SCHEMA_URL,
  componentType: EVENT_COUNTDOWN_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: EventCountdownAdd,
    dragComponentView: EventCountdownGrabber,
    editComponentView: EventCountdownEdit,
    createComponentView: EventCountdownEdit,
  },
} as const;
